import { Vue, Component, Prop, Watch, Inject } from 'vue-property-decorator';
import bodyComponent from '@/entities/report-insights/template-report/template-one/body-component';
import referenceComponent from '@/entities/report-insights/template-report/template-one/reference-component';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import reportRelated from '@/entities/report-insights/report-related-peoples/report-related-people.vue';
import { BASE64_LOGO_DATA } from '@/util/base64-string-data';
import moment from 'moment';
import type { IResourceModel } from '@/shared/model/briefing-widget.model';
import { namespace } from 'vuex-class';
import { downloadFilePDFCommon } from '@/util/common-util';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  HeadingLevel,
  Alignment,
  ImageRun,
  PageBreak,
  TableOfContents,
  Table,
  TableRow,
  TableCell,
  WidthType,
  Styles,
  ExternalHyperlink,
} from 'docx';
import { ISpacingProperties } from 'docx/build/file/paragraph/formatting/spacing';
import { isOutOfDateMakeAThon } from '@/util/ds-util';
import ReportComments from '@/entities/report-insights/comments/ReportComments.vue';
import ReportFooter from '@/entities/report-insights/report-footer/report-footer.vue';

const appStoreState = namespace('appStore');
const briefingStore = namespace('briefingStore');

@Component({
  computed: {
    moment() {
      return moment;
    },
  },
  components: {
    'body-component': bodyComponent,
    'reference-component': referenceComponent,
    'report-footer': ReportFooter,
    vueCustomScrollbar: vueCustomScrollbar,
    reportRelated,
    ReportComments,
  },
})
export default class ReportContent extends Vue {
  @Prop(Boolean) readonly loading: boolean | false;
  @Prop(Boolean) readonly detailReport: boolean | false;
  @Prop() readonly dataHeading: any | undefined;
  @Prop() readonly headingSelected: any | undefined;
  @Prop(Array) readonly dataBody: any | [];
  @Prop(Object) readonly dataTableOfContent: any | undefined;
  @Prop(Object) readonly dataReference: any | undefined;
  @Prop() readonly logo: any | undefined;
  @Prop() readonly selectedComponent: any | undefined;
  @Prop(Array) readonly articleRelatedPeople: any | [];
  @Prop(Array) readonly articleRelatedDocument: any | [];
  @Prop(String) readonly ownerUserKey: string | '';
  @Prop(String) readonly reportType: string | '';
  @Prop(Number) readonly viewCount: number | 0;
  @Prop(Boolean) readonly displayPolarisView: boolean | false;
  @Prop(Boolean) readonly displayPolarisEdit: boolean | false;
  @Prop(Boolean) readonly isEdited!: boolean | false;

  textFont = 'Noto Sans';
  sectionSpacing: ISpacingProperties = {
    before: 125, // Space before the paragraph in twips (1 twip = 1/20 pt)
    after: 140, // Space after the paragraph in twips
    line: 312, // line spacing in twips (240 twips = 12pt)
    lineRule: 'auto', // use 'auto' or 'exact'
  };

  @briefingStore.Getter
  public getSelectedResource!: IResourceModel;

  @appStoreState.Mutation
  public setIsShowPopupSubmitReport!: (payload: boolean) => void;

  @appStoreState.Getter
  public isShowDetailReport!: boolean;

  contentReference: any[] = [];
  selectedIndex: any = 0;
  currentLanguage = localStorage.getItem('currentLanguage') !== undefined ? localStorage.getItem('currentLanguage') : 'en';
  localStorageUser = JSON.parse(localStorage.getItem('localStorageUser')) || null;
  ownerReport = '';
  userLogin = '';
  imagesKo = [
    'content/images/images_v3/event/go-event-241111-makerthon-report-A-kor.jpg',
    'content/images/images_v3/event/go-event-241111-makerthon-report-B-kor.jpg',
  ];
  imagesEn = [
    'content/images/images_v3/event/go-event-241111-makerthon-report-A-eng.jpg',
    'content/images/images_v3/event/go-event-241111-makerthon-report-B-eng.jpg',
  ];
  randomImageEn = 'content/images/images_v3/event/go-event-241111-makerthon-report-A-eng.jpg';
  randomImageKo = 'content/images/images_v3/event/go-event-241111-makerthon-report-A-kor.jpg';

  goToGuide = `${window.origin}/guide`;
  isDueDateMakeAThon = false;

  isShowPopupSubmitReport = false;

  @Watch('displayPolarisEdit')
  isDisplayPolarisEditChange(newval: any) {
    if (newval && !this.isEdited) {
      this.downloadAsWord();
    }
  }

  // @Watch('displayPolarisView')
  // isDisplayPolarisViewChange(newval: any) {
  //   if (newval) {
  //     this.downloadAsWord();
  //   }
  // }

  @Watch('headingSelected')
  isChangeDataHeading() {
    if (this.headingSelected == '' || this.headingSelected == null) {
      this.selectedIndex = -1;
    }
  }

  // loadAd() {
  //   const adContainer = document.getElementById('ad-container');
  //
  //   const ins = document.createElement('ins');
  //   ins.className = 'adsbygoogle';
  //   ins.style.display = 'block';
  //   ins.setAttribute('data-ad-client', 'ca-pub-5343775931420563');
  //   ins.setAttribute('data-ad-slot', '1496814805');
  //   ins.setAttribute('data-ad-format', 'auto');
  //   ins.setAttribute('data-full-width-responsive', 'true');
  //   adContainer.appendChild(ins);
  //
  //   // @ts-ignore
  //   (adsbygoogle = window.adsbygoogle || []).push({});
  // }

  created() {
    this.isDueDateMakeAThon = isOutOfDateMakeAThon();
    this.$root.$on('downloadAsWord', this.downloadAsWord);
    this.$root.$on('downloadReportAsPDF', this.downloadReportAsPDF);
    if (this.getSelectedResource?.userProfile) {
      this.ownerReport = this.getSelectedResource.userProfile.userKey;
    } else {
      this.ownerReport = '';
    }
    this.userLogin = this.$store.getters?.userIdentity?.id || JSON.parse(localStorage.getItem('localStorageUser'))?.id;
  }

  mounted() {
    this.randomizeImage();
    // this.loadAd();
  }

  destroyed() {
    this.$root.$off('downloadAsWord', this.downloadAsWord);
    this.$root.$off('downloadReportAsPDF', this.downloadReportAsPDF);
  }

  selectBody(component, arrDocId, heading) {
    this.$emit('selectBody', component, arrDocId, heading);
  }

  imageStyle() {
    return {
      width: '100%',
      display: this.loading ? 'inline' : 'none',
      transition: 'all 1s',
      animation: this.loading ? 'fadeIn 2s linear' : 'none',
    };
  }

  selectComponent(component: string, arrDocId) {
    this.$emit('selectComponent', component, arrDocId);
  }

  customeTextRun(text, size?, font?, bold?) {
    return new TextRun({
      text: text,
      size: size || 22,
      font: font || this.textFont,
      bold: bold || false,
    });
  }

  getTableHeader(headers) {
    const tableHeader = new TableRow({
      children: headers.map(header => {
        return new TableCell({
          width: { size: 3000, type: WidthType.DXA },
          children: [
            new Paragraph({
              children: [
                new TextRun({
                  text: header.name || '',
                  bold: true,
                  font: this.textFont,
                }),
              ],
            }),
          ],
        });
      }),
    });
    return tableHeader;
  }

  getTableContent(datas, columnOrder) {
    // console.log('raw getTableContent data: ', datas);
    const tableContent = [];
    datas.map(data => {
      tableContent.push(
        new TableRow({
          children: columnOrder.map(column => {
            return new TableCell({
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: data?.[column.name] || '',
                      font: this.textFont,
                    }),
                  ],
                }),
              ],
            });
          }),
        })
      );
    });
    // console.log('getTableContent data: ', tableContent);
    return tableContent;
  }

  getReportReference(data, index) {
    const referenceArray = [];
    data?.elements.map(element => {
      if (element?.element_type?.startsWith('heading') || element?.elementType?.startsWith('heading')) {
        referenceArray.push(
          new Paragraph({
            alignment: 'start',
            children: [
              new TextRun({
                text: element.content,
                size: 36,
                color: '000000', // Black color
                font: this.textFont,
              }),
            ],
            spacing: {
              before: 500, // Space before the paragraph in twips (1 twip = 1/20 pt)
              after: 300, // Space after the paragraph in twips
            },
            heading: HeadingLevel.HEADING_1,
          })
        );
      } else if (element?.element_type === 'list' || element?.elementType === 'list') {
        element?.contents?.map((content, index) => {
          referenceArray.push(
            new Paragraph({
              alignment: 'start',
              children: [
                new TextRun({
                  text: `${index + 1}. ${content?.title || ''}`,
                  size: 20,
                  color: '000000', // Black color
                  font: this.textFont,
                }),
              ],
              spacing: {
                after: 100,
              },
            }),
            new Paragraph({
              alignment: 'start',
              children: [
                new ExternalHyperlink({
                  children: [
                    new TextRun({
                      text: content?.url || '',
                      size: 18,
                      font: this.textFont,
                      color: '5F6B74',
                      style: 'Hyperlink',
                    }),
                  ],
                  link: content?.url || '',
                }),
              ],
              spacing: {
                after: 120,
              },
            })
          );
        });
      }
    });
    return referenceArray;
  }

  getReportContent(data, index) {
    // console.log('raw data: ', data.elements);
    let contentArray = [];
    let subIndex = 0;
    contentArray = data?.elements.flatMap(element => {
      if (element?.element_type?.startsWith('heading') || element?.elementType?.startsWith('heading')) {
        return new Paragraph({
          alignment: 'start',
          children: [
            new TextRun({
              text:
                element.element_type === 'heading' || element.elementType === 'heading'
                  ? `${index + 1}. ${element.content}`
                  : element.content,
              bold: true,
              size: 36,
              color: '000000', // Black color
              font: this.textFont,
            }),
          ],
          spacing: {
            before: 500, // Space before the paragraph in twips (1 twip = 1/20 pt)
            after: 220, // Space after the paragraph in twips
          },
          heading: HeadingLevel.HEADING_1,
        });
      } else if (element?.element_type?.startsWith('subheading') || element?.elementType?.startsWith('subheading')) {
        subIndex++;
        return new Paragraph({
          alignment: 'start',
          children: [
            new TextRun({
              text:
                element.element_type === 'subheading' || element.elementType === 'subheading'
                  ? `${index + 1}-${subIndex}. ${element.content || ''}`
                  : element.content,
              bold: true,
              size: 28,
              color: '000000', // Black color
              font: this.textFont,
            }),
          ],
          spacing: {
            before: 125, // Space before the paragraph in twips (1 twip = 1/20 pt)
            after: 125, // Space after the paragraph in twips
          },
          heading: HeadingLevel.HEADING_2,
        });
      } else if (element?.element_type?.startsWith('list') || element?.elementType?.startsWith('list')) {
        return new Paragraph({
          alignment: 'start',
          children: [...element.content.map(content => this.customeTextRun(content)), new TextRun(' ')],
          spacing: this.sectionSpacing,
        });
      } else if (element?.element_type === 'bullet_lst' || element?.elementType === 'bullet_lst') {
        return new Paragraph({
          alignment: 'start',
          children: [new TextRun({ text: element.content || '', font: this.textFont })],
          bullet: {
            level: 0, // Level 0 for top-level bullet
          },
          spacing: this.sectionSpacing,
        });
      } else if (element?.element_type === 'grid' || element?.elementType === 'grid') {
        const paragraphs = element.content.flatMap(c => {
          return [
            new Paragraph({
              alignment: 'start',
              children: [
                new TextRun({
                  text: c.elements[0]?.content || '',
                  font: this.textFont,
                  bold: true,
                  size: 32,
                }),
              ],
              spacing: this.sectionSpacing,
            }),
            new Paragraph({
              alignment: 'start',
              children: [new TextRun({ text: c.elements[1]?.content.join('. ') || '', font: this.textFont })],
              spacing: {
                before: 90, // Space before the paragraph in twips (1 twip = 1/20 pt)
                after: 125, // Space after the paragraph in twips
              },
            }),
          ];
        });
        return paragraphs;
      } else if (element?.element_type === 'table' || element?.elementType === 'table') {
        const headers = element?.content?.schema?.fields || [];
        const totalColumns = headers.length;
        const columnWidth = Math.floor(10000 / totalColumns);
        return new Table({
          rows: [
            this.getTableHeader(element?.content?.schema?.fields),
            ...this.getTableContent(element?.content?.data, element?.content?.schema?.fields),
          ],
          columnWidths: element?.content?.schema?.fields.map(() => columnWidth),
        });
      } else {
        return new Paragraph({
          alignment: 'start',
          children: Array.isArray(element?.content)
            ? element?.content?.map(content => new TextRun({ text: content || '', bold: true, font: this.textFont }))
            : [new TextRun({ text: element.content || '', bold: true, font: this.textFont })],
          spacing: {
            before: 125, // Space before the paragraph in twips (1 twip = 1/20 pt)
            after: 125, // Space after the paragraph in twips
          },
        });
      }
    });
    // console.log('contentArray', contentArray);
    return contentArray;
  }

  async fetchImageFromS3(imageUrl) {
    try {
      const response = await fetch(imageUrl);
      if (!response.ok) {
        throw new Error('Failed to fetch image from S3');
      }
      const arrayBuffer = await response.arrayBuffer();
      return new Uint8Array(arrayBuffer); // Convert to Uint8Array
    } catch (error) {
      return new Uint8Array();
    }
  }

  async downloadAsWord() {
    const imageCoverBuffer = await this.fetchImageFromS3(this.dataHeading.data.title_image.content);
    const imageCoverImageRun = new ImageRun({
      data: imageCoverBuffer,
      transformation: {
        width: 600,
        height: 600,
      },
      altText: {
        title: 'This is an ultimate title',
        description: 'This is an ultimate image',
        name: 'My Ultimate Image',
      },
    });

    const gooverLogoImageRun = new ImageRun({
      data: BASE64_LOGO_DATA,
      transformation: {
        width: 100,
        height: 28,
      },
      altText: {
        title: 'This is an ultimate title',
        description: 'This is an ultimate image',
        name: 'My Ultimate Image',
      },
    });

    let tableOfContent = undefined;
    if (!this.dataTableOfContent.data.table_of_entry.length) {
      tableOfContent = undefined;
    } else {
      tableOfContent = new Paragraph({
        children: [
          new TableOfContents(''),
          new Paragraph({
            text: 'Introduction',
            heading: HeadingLevel.HEADING_2,
          }),
          new Paragraph('This is the introduction section.'),
          new Paragraph({
            text: 'Chapter 1',
            heading: HeadingLevel.HEADING_2,
          }),
          new Paragraph('This is the content of chapter 1.'),
          new Paragraph({
            text: 'Chapter 2',
            heading: HeadingLevel.HEADING_2,
          }),
          new Paragraph('This is the content of chapter 2.'),
        ],
      });
    }

    const doc = new Document({
      sections: [
        {
          children: [
            // first page
            new Paragraph({
              // heading: HeadingLevel.HEADING_1,
              alignment: 'center',
              children: imageCoverBuffer?.length ? [imageCoverImageRun] : [],
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: this.dataHeading.data.title.content,
                  size: 48,
                  color: '000000',
                  bold: true,
                  font: this.textFont,
                }),
              ],
              alignment: 'center',
              spacing: {
                before: 600, // Space before the paragraph in twips (1 twip = 1/20 pt)
                after: 350, // Space after the paragraph in twips
              },
            }),
            new Paragraph({
              alignment: 'center',
              children: [
                new TextRun({
                  text: this.dataHeading.data.publisher.content + ' ' + this.dataHeading.data.date.content,
                  size: 33,
                  bold: true,
                  font: this.textFont,
                  color: '000000', // Black color
                }),
              ],
            }),
            new Paragraph({
              alignment: 'center',
              children: [gooverLogoImageRun, new PageBreak()],
              spacing: {
                before: 1000, // Space before the paragraph in twips (1 twip = 1/20 pt)
                after: 550, // Space after the paragraph in twips
              },
            }),
            // tableOfContent,
            ...this.dataBody.flatMap((data, index) => this.getReportContent(data, index)),
            // report reference
            ...this.getReportReference(this.dataReference, this.dataBody.length + 1),
          ],
        },
      ],
    });

    // console.log('expected data: ', this.dataBody.flatMap(data => this.getReportContent(data.elements, undefined)));
    const blob = await Packer.toBlob(doc);
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    const filename = this.dataHeading?.data?.title?.content;
    link.download = filename ? filename + '.docx' : 'document.docx';
    if (this.displayPolarisEdit && !this.isEdited) {
      this.$emit('file', blob, link.download);
    } else {
      link.click();
    }
  }

  getImgBase64(elementId) {
    const img = document.getElementById(elementId);
    console.log('found element', img);
    // Create a canvas element
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    // Set canvas dimensions to match the image
    // @ts-ignore
    canvas.width = img.width;
    // @ts-ignore
    canvas.height = img.height;

    // Draw the image on the canvas
    // @ts-ignore
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

    // Get the base64 string from the canvas
    const base64String = canvas.toDataURL('image/jpeg'); // or 'image/png'

    // Output or use the base64 string
    console.log('base64String', base64String);
    return base64String;
  }

  downloadReportAsPDF() {
    try {
      downloadFilePDFCommon(this.dataBody, this.dataTableOfContent, this.dataHeading, this.dataReference);
    } catch (e) {
      console.log('Download failed pdf by custom text with error: ', e);
      this.downloadPdfByImage();
    }
  }

  async downloadPdfByImage() {
    try {
      const element = document.getElementById('contentToPrint');
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
      });

      const context = canvas.getContext('2d');
      context.globalCompositeOperation = 'lighter';

      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');

      const imgWidth = 210;
      const pageHeight = 295;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      const heightLeft = imgHeight;

      let position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);

      let remainingHeight = heightLeft - pageHeight;

      while (remainingHeight > 0) {
        pdf.addPage();
        position = remainingHeight - imgHeight;
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        remainingHeight -= pageHeight;
      }

      let pdfName = '';
      if (this.dataHeading?.data?.title?.content) {
        pdfName = this.dataHeading?.data?.title?.content + '.pdf';
      } else {
        pdfName = 'Report.pdf';
      }

      pdf.save(pdfName);
    } catch (e) {
      console.log('Download failed pdf image with error: ', e);
    }
  }

  updateSelectedIndex(index) {
    this.selectedIndex = index;
  }

  randomizeImage() {
    this.randomImageKo = this.getRandomImage(this.imagesKo);
    this.randomImageEn = this.getRandomImage(this.imagesEn);
  }

  private getRandomImage(images: string[]): string {
    const randomIndex = Math.floor(Math.random() * images.length);
    return images[randomIndex];
  }

  openToVote() {
    window.open(`${window.origin}/guide`);
  }
}
